module.exports = __webpack_public_path__ + "img/test21.d6925c7c.png";